import React from 'react'
import get from 'lodash/get'
import { ILabelsList } from './Interfaces'
import StyledListLabel from './StyledListLabel'
import StyledLabelWrapper from './StyledLabelListWrapper'
import { TextAlignment } from '@modules/common/models/enums'
import { ApplyToFixedIfNumber } from '@services/commonServices'
import Tooltip from '@material-ui/core/Tooltip'
import { withIconHOC } from '@components/std-components/Icons'
import * as css from './LabelList.css'

export const LabelList: React.FunctionComponent<ILabelsList> = React.memo(
  ({
    data,
    dataKey,
    hasGlobalRow,
    isFloatingPointValue,
    alignment = TextAlignment.right,
    icon,
    iconKey
  }) => {
    const FlaggedIcon = withIconHOC({
      imageSrc: icon,
      className: css['flagIcon']
    })
    return (
      <React.Fragment>
        {data && data.length
          ? data.map((labelObject, index) => {
              const value = isFloatingPointValue
                ? ApplyToFixedIfNumber(get(labelObject, dataKey))
                : get(labelObject, dataKey)
              return (
                <StyledLabelWrapper key={`${value}_${index}`} alignment={alignment}>
                  {get(labelObject, iconKey) ? <FlaggedIcon /> : null}
                  <Tooltip title={value || ''}>
                    <div>
                      <StyledListLabel index={index} hasGlobalRow={hasGlobalRow}>
                        {value}
                      </StyledListLabel>
                    </div>
                  </Tooltip>
                </StyledLabelWrapper>
              )
            })
          : null}
      </React.Fragment>
    )
  }
)
